type SpendfitConfig = {
  apiUrl?: string
  criptoKey?: string
  gtmEnabled?: string
  gtmKey?: string
  fcmKeyPair?: string
  fcmServerKey?: string
}

declare global {
  interface Window {
    __SPENDFIT_CONFIG__?: SpendfitConfig
  }
}

function fromRuntime(value: string | undefined, fallback: string | undefined): string {
  if (value != null && value !== '') return value
  return fallback ?? ''
}

export function apiUrl(): string {
  return fromRuntime(window.__SPENDFIT_CONFIG__?.apiUrl, import.meta.env.VITE_API_URL)
}

export function criptoKey(): string {
  return fromRuntime(window.__SPENDFIT_CONFIG__?.criptoKey, import.meta.env.VITE_CRIPTO_KEY)
}

export function gtmEnabled(): boolean {
  const value = fromRuntime(window.__SPENDFIT_CONFIG__?.gtmEnabled, import.meta.env.VITE_APP_GTM_ENABLED)
  return value === 'true' || value === '1'
}

export function gtmKey(): string {
  return fromRuntime(window.__SPENDFIT_CONFIG__?.gtmKey, import.meta.env.VITE_APP_GTM_KEY)
}

export function fcmKeyPair(): string {
  return fromRuntime(window.__SPENDFIT_CONFIG__?.fcmKeyPair, import.meta.env.VITE_APP_FCM_KEY_PAIR)
}

export function fcmServerKey(): string {
  return fromRuntime(window.__SPENDFIT_CONFIG__?.fcmServerKey, import.meta.env.VITE_APP_FCM_SERVER_KEY)
}
